'use client';

import { useMedia } from 'react-use';

export const useIsMobile = () => {
  const isMobile = useMedia('(max-width: 768px)', false);
  return isMobile;
};
